import React from 'react'
import useCareerSearchForm from './useCareerSeachForm'
import { InputField } from '../shared/FormFields'
import { Form } from '~/lib/ui/form'
import { Button } from '~/lib/ui/button'
import SavedStatusIcon from '../shared/SavedStatusIcon'
import * as translations from '../CareerExploration/locales.json'
import useTranslation, {
  TranslationProvider,
} from '../shared/TranslationProvider'
import { PageHeading } from '../CareerExploration/Results'
import YnsIcon from '../icons/YnsIcon'

const CareerSearch = ({ sampleTitles, occupation, reportedTitle, locale }) => {
  return (
    <TranslationProvider
      scope="javascript.components.CareerExploration"
      locale={locale}
      translations={translations}
    >
      <div
        className={
          'flex h-screen flex-col font-roboto text-cod-gray-800 xl:grid xl:grid-cols-[1fr]'
        }
      >
        <div
          className={`home-container flex min-h-0 flex-col overflow-y-auto p-4 md:p-9`}
        >
          <div className="tw-enable font-[Roboto] lg:flex lg:flex-row">
            <div className="flex-grow">
              <PageHeading />
              <div className="flex flex-col gap-8 divide-y divide-[#B9B9B9]">
                <CareerSearchForm sampleTitles={sampleTitles} />
                <CareerSearchForm
                  compare
                  sampleTitles={sampleTitles}
                  className="mt-8"
                  occupation={occupation}
                  reportedTitle={reportedTitle}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </TranslationProvider>
  )
}

export default CareerSearch

const CareerSearchForm = ({
  className,
  sampleTitles,
  compare,
  occupation,
  reportedTitle,
}) => {
  const { t } = useTranslation('CareerSearchForm')
  const { form, onSubmit, submitted, buttonStatus } = useCareerSearchForm({
    sampleTitles,
    compare,
    occupation,
    reportedTitle,
  })
  const title = compare ? t('compare') : t('search')
  const description = compare
    ? t('compare_description')
    : t('search_description')

  const hint = compare ? t('compare_hint') : t('search_hint')
  return (
    <div className={className}>
      <h2 className={'mt-8'}>{title} </h2>
      <div className="my-4">{description} </div>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="flex items-end gap-16">
            <InputField
              control={form.control}
              name="what"
              data-source="sample_titles"
              label={compare ? t('career_one_label') : t('search_label')}
              className={compare ? 'flex-grow-[2]' : 'flex-grow-[6]'}
            />
            {compare && (
              <InputField
                control={form.control}
                name="what2"
                label={t('career_two_label')}
                data-source="sample_titles"
                className="flex-grow-[2]"
              />
            )}
            <Button
              disabled={submitted}
              type="submit"
              className="mt-4 flex-grow-[2]"
            >
              {t(buttonStatus)}
              <SavedStatusIcon loadingStatus={buttonStatus} />
            </Button>
          </div>
        </form>
      </Form>
      <div className="mt-4 flex items-center gap-2">
        <YnsIcon name="tips" />
        <span>{hint}</span>
      </div>
    </div>
  )
}
